
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-60ffae6a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ZipAndAgeDirect.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ZipAndAgeDirect.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-60ffae6a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ZipAndAgeDirect.vue"),
  /* scopeId */
  "data-v-60ffae6a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/start/ZipAndAgeDirect.vue
// module id = 314
// module chunks = 1